// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CatalogBody_wrapper__CS9ix","segment":"CatalogBody_segment__m7wyQ"};